import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import type { LoaderState } from '../models/loader-state';

@Injectable({
  providedIn: 'root',
})
export class ApiLoaderService {
  private readonly loaderStateSubject = new BehaviorSubject<LoaderState>({
    show: false,
  });
  loaderState = this.loaderStateSubject.asObservable();

  show(): void {
    this.loaderStateSubject.next({ show: true });
  }

  hide(): void {
    this.loaderStateSubject.next({ show: false });
  }
}
